import { Compass, Building2, Home, TrendingUp, Landmark, Handshake } from "lucide-react";
import { PageShell } from "../components/PageShell";
import { PageHero } from "../components/PageHero";
import { SERVICES, SERVICE_STEPS } from "../data/content";

const ICONS = { compass: Compass, building: Building2, home: Home, "trending-up": TrendingUp, landmark: Landmark, handshake: Handshake };

export default function OurServices() {
  return (
    <PageShell>
      <PageHero
        eyebrow="Our Services"
        title="End-to-end property advisory,"
        italic="from brief to handover"
        subtitle="Whether you are buying your first Dubai property or structuring a multi-asset portfolio, we work quietly and objectively on your behalf."
      />

      <section className="py-16 md:py-24 px-6 md:px-12">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="services-grid">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || Compass;
            return (
              <div key={s.title} className="glass rounded-2xl p-8 hover:border-[#c5a059]/40 transition" data-testid={`service-${i}`}>
                <div className="w-11 h-11 rounded-lg bg-[#c5a059]/15 flex items-center justify-center mb-5">
                  <Icon size={18} className="text-[#c5a059]" strokeWidth={1.5} />
                </div>
                <h3 className="font-serif-display text-2xl mb-3">{s.title}</h3>
                <p className="text-white/60 leading-relaxed text-sm">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </section>

      <section className="py-16 md:py-24 px-6 md:px-12 border-t border-white/5">
        <div className="max-w-6xl mx-auto">
          <div className="text-[10px] tracking-[0.5em] text-[#c5a059] uppercase mb-4">How we work</div>
          <h2 className="font-serif-display text-3xl md:text-5xl font-light mb-14">A structured, <em className="italic gold-gradient">unhurried</em> process</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {SERVICE_STEPS.map((s) => (
              <div key={s.n} className="glass rounded-xl p-6" data-testid={`step-${s.n}`}>
                <div className="font-serif-display text-4xl text-[#c5a059] mb-3">{s.n}</div>
                <h3 className="font-serif-display text-xl mb-2">{s.title}</h3>
                <p className="text-white/60 text-sm leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </PageShell>
  );
}
